export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  GET_ROLE_PERMISSION: 'GET_ROLE_PERMISSION',
}
